var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPasswordchanged = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 184,
  height: 182,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 174.5,
  cy: 34.502,
  fill: "#FDCC09",
  rx: 9,
  ry: 8.872
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.5,
  cy: 172.512,
  fill: "#70C6D1",
  rx: 9,
  ry: 8.872
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 157,
  cy: 151.318,
  fill: "#91C653",
  rx: 4.5,
  ry: 4.436
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 13,
  cy: 93.156,
  fill: "#323333",
  rx: 4.5,
  ry: 4.436
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.5,
  cy: 8.872,
  fill: "#F15859",
  rx: 9,
  ry: 8.872
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#passwordchanged_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#91C653",
  d: "M120.317 90.999a9.03 9.03 0 0 0 1.872-8.224 9.03 9.03 0 0 0-5.733-6.185 9.03 9.03 0 0 0-6.212-10.302 9 9 0 0 0-4.337-.246 9.04 9.04 0 0 0-6.186-5.735 9.03 9.03 0 0 0-8.223 1.875 9.034 9.034 0 0 0-14.41 3.861 9.034 9.034 0 0 0-10.546 10.55A9.035 9.035 0 0 0 62.681 91a9.032 9.032 0 0 0 3.862 14.409 9.032 9.032 0 0 0 10.548 10.547 9.03 9.03 0 0 0 10.53 5.816 9 9 0 0 0 3.88-1.955 9.04 9.04 0 0 0 8.224 1.873 9.05 9.05 0 0 0 3.803-2.101 9.04 9.04 0 0 0 2.381-3.634 9.03 9.03 0 0 0 10.548-10.548 9.033 9.033 0 0 0 3.86-14.41"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "m85.934 102.832-8.615-8.609a1.746 1.746 0 0 1 0-2.468l1.047-1.048a1.746 1.746 0 0 1 2.468 0l6.262 6.258 14.747-15.672a1.75 1.75 0 0 1 2.467-.075l1.075 1.014a1.746 1.746 0 0 1 .075 2.468l-17.017 18.093a1.75 1.75 0 0 1-1.246.552 1.76 1.76 0 0 1-1.263-.513"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "passwordchanged_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60.5 60h62v62h-62z"
})))));
export { SvgPasswordchanged as ReactComponent };
export default __webpack_public_path__ + "b34de8a6c023bc8718c23de55f2f58b0.svg";